import React, {useCallback} from 'react';
import {TaskEditorCore} from './TaskEditorCore';
import {Task} from '../../models/types';
import {App} from "../../app/AppSingleton";
import {PortalWrapper} from "./PortalWrapper";

interface InlineTaskEditorProps {
	task: Task;
	onClose: (isDeleted: boolean) => void;
	onSave: (title: string) => Promise<void>;
	onDelete?: () => Promise<void>;
	cardRef?:  React.RefObject<HTMLElement>
}

const InlineTaskEditor: React.FC<InlineTaskEditorProps> = (props) => {
	const handleDelete = useCallback(async () => {
		try {
			await App.getInstance().getTaskEditController().deleteTask();
			props.onClose(true);
		} catch (error) {
			console.error('Error deleting task:', error);
		}
	}, [props.onClose]);

	const handleSubmit = useCallback(async (title: string) => {
		if (!title.trim()) return;
		await props.onSave(title.trim());
	}, [props.onSave]);

	const handleClose = useCallback((isDeleted:boolean) => {
		props.onClose(isDeleted);
	}, [props.onClose]);

	return (
		<PortalWrapper enabled={true} className={"editor-portal"} targetRef={props.cardRef}>
			<TaskEditorCore
				mode="edit"
				initialTitle={props.task.title}
				onSubmit={handleSubmit}
				onClose={handleClose}
				onCancel={()=>props.onClose(false)}
				onDelete={handleDelete}
				autoFocus={true}
				showCancelButton={true}
				className="task-editor-core--inline"
				inputClassName="task-editor-core__input--inline"
				actionsPosition="footer"
				columnId={props.task.columnId}
				boardId={props.task.boardId}
				taskId={props.task.id}
			/>
		</PortalWrapper>
	);
};

export default InlineTaskEditor;